import { render } from "./SimpleUploadAndTerms.vue?vue&type=template&id=083f2be8&scoped=true"
import script from "./SimpleUploadAndTerms.vue?vue&type=script&lang=js"
export * from "./SimpleUploadAndTerms.vue?vue&type=script&lang=js"

import "./SimpleUploadAndTerms.vue?vue&type=style&index=0&id=083f2be8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083f2be8"]])

export default __exports__